/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable no-continue */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-rest-params */
/* eslint-disable camelcase */
const jsUrlHelper = {
  getUrlParam(url, ref) {
    let str = "";

    // 如果不包括此参数
    if (url.indexOf(ref) === -1) return "";

    str = url.substr(url.indexOf("?") + 1);

    const arr = str.split("&");
    for (const value of arr) {
      const paired = value.split("=");

      if (paired[0] === ref) {
        const val = decodeURIComponent(paired[1]); // 解码
        return val;
      }
    }

    return "";
  },
  putUrlParam(url, ref, value) {
    // 如果没有参数
    if (url.indexOf("?") === -1) return `${url}?${ref}=${value}`;

    // 如果不包括此参数
    if (url.indexOf(ref) === -1) return `${url}&${ref}=${value}`;

    const arr_url = url.split("?");

    const base = arr_url[0];

    const arr_param = arr_url[1].split("&");

    for (let i = 0; i < arr_param.length; i++) {
      const paired = arr_param[i].split("=");

      if (paired[0] === ref) {
        paired[1] = value;
        arr_param[i] = paired.join("=");
        break;
      }
    }

    return `${base}?${arr_param.join("&")}`;
  },
  delUrlParam(url, ref) {
    // 如果不包括此参数
    if (url.indexOf(ref) === -1) return url;
    const arr_url = url.split("?");
    const base = arr_url[0];
    const arr_param = arr_url[1].split("&");
    let index = -1;
    for (let i = 0; i < arr_param.length; i++) {
      const paired = arr_param[i].split("=");
      if (paired[0] === ref) {
        index = i;
        break;
      }
    }
    if (index === -1) {
      return url;
    }
    arr_param.splice(index, 1);
    return `${base}?${arr_param.join("&")}`;
  },
  herfUrl(url) {
    const regex = /data=(.*)/;
    const match = url.match(regex);
    const dataValue = match[1];
    return dataValue
  },
  /**
   * 获取当前 url 的 params 对象
   * @example
   * getParamObj("https://www.hycan.com/index.html?ie=UTF-8&wd=localstorage") => {ie: "UTF-8", wd: "localstorage"}
   * @param {String} url
   * @returns {Object}
   */
  getParamObj(url) {
    if (url.indexOf("?") === -1) return {};

    const params = {};
    const queryParams = url.slice(url.indexOf("?") + 1);
    const vars = queryParams ? queryParams.split("&") : [];

    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split("=");
      params[pair[0]] = pair[1];
    }

    return params;
  },

  /**
   * 给 url 添加 param 参数，并返回新的 url
   * @example
   * addParamObjToUrl("https://www.hycan.com/index.html", {a: 1, b: 3}) => "https://www.hycan.com/index.html?a=1&b=3"
   * addParamObjToUrl("https://www.hycan.com/index.html?c=2", {a: 1, b: 3}) => "https://www.hycan.com/index.html?c=2&a=1&b=3"
   * @param {String} url
   * @param {Object} paramObj
   * @returns {String}
   */
  addParamObjToUrl({ url, query = {} }) {
    let queryStr = "";
    Object.entries(query).forEach((item) => {
      // 如果参数没有值，就不拼上去
      if (item[1] === "" || item[1] === null || item[1] === undefined) {
        return false;
      }
      if (queryStr) {
        queryStr = `${queryStr}&${item[0]}=${item[1]}`;
      } else {
        queryStr = `${item[0]}=${item[1]}`;
      }
    });
    if (url.includes("?")) {
      return queryStr ? `${url}&${queryStr}` : url;
    }
    return `${url}?${queryStr}`;
  },
};

/**
 * 复制文字工具方法
 * 兼容性补充：
 * 移动端：
 * 安卓手机：微信（chrome）和几个手机浏览器都可以用。
 * 苹果手机：微信里面和sarafi浏览器里也都可以，
 * PC:safari版本必须在10.2以上，其他浏览器可以.
 * 兼容性测试网站：https://www.caniuse.com/
 * 必须手动触发 点击事件或者其他事件，不能直接使用js调用！！！
 * 例如：copyText('h5实现一键复制到粘贴板 兼容ios')
 */
export const copyText = (text, callback) => {
  // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
  // 选择文本。createTextRange(setSelectionRange)是input方法
  function selectText(textbox, startIndex, stopIndex) {
    if (textbox.createTextRange) {
      // ie
      const range = textbox.createTextRange();
      range.collapse(true);
      range.moveStart("character", startIndex); // 起始光标
      range.moveEnd("character", stopIndex - startIndex); // 结束光标
      range.select(); // 不兼容苹果
    } else {
      // firefox/chrome
      textbox.setSelectionRange(startIndex, stopIndex);
      textbox.focus({
        preventScroll: true,
      });
    }
  }

  // 数字没有 .length 不能执行selectText 需要转化成字符串
  const textString = text.toString();
  let input = document.querySelector("#copy-input");
  if (!input) {
    input = document.createElement("input");
    input.id = "copy-input";
    input.readOnly = true; // 防止ios聚焦触发键盘事件
    input.style.position = "absolute";
    input.style.left = "0px";
    input.style.top = "100%";
    input.style.zIndex = "-1000";
    input.style.opacity = 0;
    document.body.appendChild(input);
  }

  input.value = textString;
  // ios必须先选中文字且不支持 input.select();
  selectText(input, 0, textString.length);
  if (document.execCommand("copy")) {
    document.execCommand("copy");
    callback && callback();
  }
  input.blur();
};

export default {
  jsUrlHelper,
  copyText,
  /**
   * 函数防抖
   * @param fn 需要进行防抖操作的事件函数
   * @param interval 间隔时间
   * @returns {Function}
   */
  debounce(fn, interval) {
    let timer;
    const gapTime = interval || 400; // 间隔时间，如果interval不传，则默认1000ms
    return function() {
      clearTimeout(timer);
      const context = this;
      const args = arguments[0]; // 保存此处的arguments，因为setTimeout是全局的，arguments无法在回调函数中获取，此处为闭包。
      timer = setTimeout(() => {
        fn.call(context, args); // args是事件处理函数默认事件参数event  call绑定当前page对象
      }, gapTime);
    };
  },
  /**
   * 节流
   * @param {*} fn 需要进行防抖操作的事件函数
   * @param {*} interval 间隔时间
   */
  throttle(fn, interval = 1000) {
    let _lastTime = null;
    return function() {
      const _nowTime = +new Date();
      if (_nowTime - _lastTime > interval || !_lastTime) {
        fn.apply(this, arguments);
        _lastTime = _nowTime;
      }
    };
  },

  /**
   * ver <= 客户端当前版本时 return true
   * @param {String} ver 最低支持的版本号
   * @returns
   */
  checkVersion(ver) {
    const u = window.navigator.userAgent;
    // 3.1.0以下版本无app_version字段
    if (!u.includes("app_version")) return false;

    const cv = u
      .split("/")
      .find((i) => i.includes("app_version"))
      .split("=")[1];
    const thisVersion = cv.replace(/[^\d.]/g, "");
    console.log("当前APP版本：", thisVersion, "比较版本：", ver);

    if (oldVer === newVer) return true;
    const oldVer = ver.split(".");
    const newVer = thisVersion.split(".");
    // 兼容APP端两段版本号问题。。。。已建议APP端后续统一采用三段式版本号
    const length =
      newVer.length > oldVer.length ? newVer.length : oldVer.length;
    for (let i = 0, j = length; i < j; i++) {
      const newN = +newVer[i] || 0;
      const oldN = +oldVer[i] || 0;
      if (newN === oldN) continue;
      return newN > oldN;
    }
    return true;
  },
};

/**
 *
 * 时间格式化
 * 使用： timeFormat("YYYY/MM/DD HH:mm:ss")
 * @param {string} formatStr 时间
 * @param {string} formatStr 时间字符串模板
 */

export const timeFormat = (date, formatStr) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const week = date.getDay();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  return formatStr.replace(
    /Y{2,4}|M{1,2}|D{1,2}|d{1}|H{1,2}|m{1,2}|s{1,2}/g,
    (match) => {
      switch (match) {
        case "YY":
          return String(year).slice(-2);
        case "YYY":
        case "YYYY":
          return String(year);
        case "M":
          return String(month);
        case "MM":
          return String(month).padStart(2, "0");
        case "D":
          return String(day);
        case "DD":
          return String(day).padStart(2, "0");
        case "d":
          return String(week);
        case "H":
          return String(hour);
        case "HH":
          return String(hour).padStart(2, "0");
        case "m":
          return String(minute);
        case "mm":
          return String(minute).padStart(2, "0");
        case "s":
          return String(second);
        case "ss":
          return String(second).padStart(2, "0");
        default:
          return match;
      }
    }
  );
};
